export const PROFILE_FIRST_NAME = 'PROFILE_FIRST_NAME';
export const PROFILE_LAST_NAME = 'PROFILE_LAST_NAME';
export const LOCALE = 'LOCALE';
export const LANGUAGE = 'LANGUAGE';
export const PHONE = 'PHONE';
export const DEFAULT_PAGE = 'DEFAULT_PAGE';